<template>
  <div class="flex-col page">
    <div class="justify-center section_1">
      <div @click="view_2OnClick" class="flex-row group">
        <img src="../assets/2faeafb609868e14baea19574eefca83.png" class="image" />
        <span class="text">返回首页</span>
      </div>
      <span class="text_1">行言君自营店</span>
      <div class="flex-row section_2">
        <div class="flex-row group_1">
          <img src="../assets/16488068565369237271.png" class="image_1" />
          <span class="text_2">输入商品名称</span>
        </div>
        <div class="flex-col items-center text-wrapper">
          <span>搜索</span>
        </div>
      </div>
    </div>
    <div class="flex-col group_2">
      <div class="flex-row">
        <div class="flex-col section_3">
          <div class="flex-row divider">
            <div class="left-section"></div>
            <span class="text_4">我的商铺</span>
          </div>
          <div class="flex-row group_4">
            <span class="text_5">8</span>
            <span class="text_6">4</span>
            <span class="text_7">2</span>
            <div class="flex-col group_5">
              <span>284</span>
              <span class="text_9">824</span>
              <span class="text_10">5325.00</span>
            </div>
            <div class="justify-between divider_1">
              <div class="flex-row group_6">
                <span>今日订单数</span>
                <span class="text_12">代发货订单</span>
                <span class="text_13">售后订单</span>
              </div>
              <div class="flex-row group_7">
                <span>访客数</span>
                <span class="text_15">今日新增收入</span>
                <span class="text_16">账户金额</span>
              </div>
            </div>
            <div class="section_4"></div>
          </div>
        </div>
        <div class="flex-col section_5">
          <div class="flex-row divider_2">
            <div class="left-section"></div>
            <span class="text_17">我的订单</span>
          </div>
          <div class="justify-around group_8">
            <span>11</span>
            <span>58</span>
            <span>2</span>
          </div>
          <div class="justify-evenly divider_3">
            <span>代付款</span>
            <span>代发货</span>
            <span>退货</span>
          </div>
        </div>
      </div>
      <div class="grid">
        <div @click="view_10OnClick" class="grid-item flex-col">
          <img src="../images/e58f36a49d7b8213bfa6f3b08d55beee.png" class="image_2" />
          <div class="center-group flex-col">
            <div class="flex-row">
              <span class="text_24">小学生笔袋</span>
              <span class="text_26">已有60人兑换</span>
            </div>
            <div class="divider_4 justify-center">
              <span class="text_28">EVA压模材质</span>
              <span>抗压耐摔</span>
            </div>
          </div>
          <div class="bottom-group justify-center">
            <div class="left-group flex-row">
              <img src="../images/62b6e44b7268aab2b7a01ebc2c3cc8b5.png" class="image_4" />
              <span>600</span>
            </div>
            <span class="text_32">兑换</span>
          </div>
        </div>
        <div @click="view_11OnClick" class="grid-item flex-col">
          <img src="../images/a16f7fe0ec730e3777874ca2f573f79c.png" class="image_2" />
          <div class="center-group flex-col">
            <div class="flex-row">
              <span class="text_24">小学生笔袋</span>
              <span class="text_26">已有60人兑换</span>
            </div>
            <div class="divider_4 justify-center">
              <span class="text_28">EVA压模材质</span>
              <span>抗压耐摔</span>
            </div>
          </div>
          <div class="bottom-group justify-center">
            <div class="left-group flex-row">
              <img src="../images/62b6e44b7268aab2b7a01ebc2c3cc8b5.png" class="image_4" />
              <span>600</span>
            </div>
            <span class="text_32">兑换</span>
          </div>
        </div>
        <div @click="view_12OnClick" class="grid-item flex-col">
          <img src="../images/451d6ab8081a12e8ad1b522ad7c7edaf.png" class="image_2" />
          <div class="center-group flex-col">
            <div class="flex-row">
              <span class="text_24">小学生笔袋</span>
              <span class="text_26">已有60人兑换</span>
            </div>
            <div class="divider_4 justify-center">
              <span class="text_28">EVA压模材质</span>
              <span>抗压耐摔</span>
            </div>
          </div>
          <div class="bottom-group justify-center">
            <div class="left-group flex-row">
              <img src="../images/62b6e44b7268aab2b7a01ebc2c3cc8b5.png" class="image_4" />
              <span>600</span>
            </div>
            <span class="text_32">兑换</span>
          </div>
        </div>
        <div @click="view_13OnClick" class="grid-item flex-col">
          <img src="../images/f7bafd9a5bd27bd2dced58c532e69b73.png" class="image_2" />
          <div class="center-group flex-col">
            <div class="flex-row">
              <span class="text_24">小学生笔袋</span>
              <span class="text_26">已有60人兑换</span>
            </div>
            <div class="divider_4 justify-center">
              <span class="text_28">EVA压模材质</span>
              <span>抗压耐摔</span>
            </div>
          </div>
          <div class="bottom-group justify-center">
            <div class="left-group flex-row">
              <img src="../images/62b6e44b7268aab2b7a01ebc2c3cc8b5.png" class="image_4" />
              <span>600</span>
            </div>
            <span class="text_32">兑换</span>
          </div>
        </div>
        <div @click="view_14OnClick" class="grid-item flex-col">
          <img src="../images/d0fa39bf5062f22a93432901bc5229de.png" class="image_2" />
          <div class="center-group flex-col">
            <div class="flex-row">
              <span class="text_24">小学生笔袋</span>
              <span class="text_26">已有60人兑换</span>
            </div>
            <div class="divider_4 justify-center">
              <span class="text_28">EVA压模材质</span>
              <span>抗压耐摔</span>
            </div>
          </div>
          <div class="bottom-group justify-center">
            <div class="left-group flex-row">
              <img src="../images/62b6e44b7268aab2b7a01ebc2c3cc8b5.png" class="image_4" />
              <span>600</span>
            </div>
            <span class="text_32">兑换</span>
          </div>
        </div>
        <div @click="view_15OnClick" class="grid-item flex-col">
          <img src="../images/4219f8ee8130bc9c9a7156c1b7136a21.png" class="image_2" />
          <div class="center-group flex-col">
            <div class="flex-row">
              <span class="text_24">小学生笔袋</span>
              <span class="text_26">已有60人兑换</span>
            </div>
            <div class="divider_4 justify-center">
              <span class="text_28">EVA压模材质</span>
              <span>抗压耐摔</span>
            </div>
          </div>
          <div class="bottom-group justify-center">
            <div class="left-group flex-row">
              <img src="../images/62b6e44b7268aab2b7a01ebc2c3cc8b5.png" class="image_4" />
              <span>600</span>
            </div>
            <span class="text_32">兑换</span>
          </div>
        </div>
        <div @click="view_16OnClick" class="grid-item flex-col">
          <img src="../images/38d7cf983d6b438ba2930ab17f95a61e.png" class="image_2" />
          <div class="center-group flex-col">
            <div class="flex-row">
              <span class="text_24">小学生笔袋</span>
              <span class="text_26">已有60人兑换</span>
            </div>
            <div class="divider_4 justify-center">
              <span class="text_28">EVA压模材质</span>
              <span>抗压耐摔</span>
            </div>
          </div>
          <div class="bottom-group justify-center">
            <div class="left-group flex-row">
              <img src="../images/62b6e44b7268aab2b7a01ebc2c3cc8b5.png" class="image_4" />
              <span>600</span>
            </div>
            <span class="text_32">兑换</span>
          </div>
        </div>
        <div @click="view_17OnClick" class="grid-item flex-col">
          <img src="../images/a68fc4ee7b94d07852101a2d7b14cba1.png" class="image_2" />
          <div class="center-group flex-col">
            <div class="flex-row">
              <span class="text_24">小学生笔袋</span>
              <span class="text_26">已有60人兑换</span>
            </div>
            <div class="divider_4 justify-center">
              <span class="text_28">EVA压模材质</span>
              <span>抗压耐摔</span>
            </div>
          </div>
          <div class="bottom-group justify-center">
            <div class="left-group flex-row">
              <img src="../images/62b6e44b7268aab2b7a01ebc2c3cc8b5.png" class="image_4" />
              <span>600</span>
            </div>
            <span class="text_32">兑换</span>
          </div>
        </div>
        <div @click="view_18OnClick" class="grid-item flex-col">
          <img src="../images/d6b249abb962ee30e796a756aa0568a6.png" class="image_2" />
          <div class="center-group flex-col">
            <div class="flex-row">
              <span class="text_24">小学生笔袋</span>
              <span class="text_26">已有60人兑换</span>
            </div>
            <div class="divider_4 justify-center">
              <span class="text_28">EVA压模材质</span>
              <span>抗压耐摔</span>
            </div>
          </div>
          <div class="bottom-group justify-center">
            <div class="left-group flex-row">
              <img src="../images/62b6e44b7268aab2b7a01ebc2c3cc8b5.png" class="image_4" />
              <span>600</span>
            </div>
            <span class="text_32">兑换</span>
          </div>
        </div>
        <div @click="view_19OnClick" class="grid-item flex-col">
          <img src="../images/2f66916fa4f241ebb55b70595a3bbb12.png" class="image_2" />
          <div class="center-group flex-col">
            <div class="flex-row">
              <span class="text_24">小学生笔袋</span>
              <span class="text_26">已有60人兑换</span>
            </div>
            <div class="divider_4 justify-center">
              <span class="text_28">EVA压模材质</span>
              <span>抗压耐摔</span>
            </div>
          </div>
          <div class="bottom-group justify-center">
            <div class="left-group flex-row">
              <img src="../images/62b6e44b7268aab2b7a01ebc2c3cc8b5.png" class="image_4" />
              <span>600</span>
            </div>
            <span class="text_32">兑换</span>
          </div>
        </div>
        <div @click="view_20OnClick" class="grid-item flex-col">
          <img src="../images/7d7f31e395ef45ba0f1ae800519f721f.png" class="image_2" />
          <div class="center-group flex-col">
            <div class="flex-row">
              <span class="text_24">小学生笔袋</span>
              <span class="text_26">已有60人兑换</span>
            </div>
            <div class="divider_4 justify-center">
              <span class="text_28">EVA压模材质</span>
              <span>抗压耐摔</span>
            </div>
          </div>
          <div class="bottom-group justify-center">
            <div class="left-group flex-row">
              <img src="../images/62b6e44b7268aab2b7a01ebc2c3cc8b5.png" class="image_4" />
              <span>600</span>
            </div>
            <span class="text_32">兑换</span>
          </div>
        </div>
        <div @click="view_21OnClick" class="grid-item flex-col">
          <img src="../images/8a97c07c25d8643977138eb47d27b3ba.png" class="image_2" />
          <div class="center-group flex-col">
            <div class="flex-row">
              <span class="text_24">小学生笔袋</span>
              <span class="text_26">已有60人兑换</span>
            </div>
            <div class="divider_4 justify-center">
              <span class="text_28">EVA压模材质</span>
              <span>抗压耐摔</span>
            </div>
          </div>
          <div class="bottom-group justify-center">
            <div class="left-group flex-row">
              <img src="../images/62b6e44b7268aab2b7a01ebc2c3cc8b5.png" class="image_4" />
              <span>600</span>
            </div>
            <span class="text_32">兑换</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {};
    },
    methods: {
      view_2OnClick() {
        this.$router.push({ name: 'wenju' });
      },
      view_10OnClick() {
        this.$router.push({ name: 'Page_shangpinxiangqingyemian' });
      },
      view_11OnClick() {
        this.$router.push({ name: 'Page_shangpinxiangqingyemian' });
      },
      view_12OnClick() {
        this.$router.push({ name: 'Page_shangpinxiangqingyemian' });
      },
      view_13OnClick() {
        this.$router.push({ name: 'Page_shangpinxiangqingyemian' });
      },
      view_14OnClick() {
        this.$router.push({ name: 'Page_shangpinxiangqingyemian' });
      },
      view_15OnClick() {
        this.$router.push({ name: 'Page_shangpinxiangqingyemian' });
      },
      view_16OnClick() {
        this.$router.push({ name: 'Page_shangpinxiangqingyemian' });
      },
      view_17OnClick() {
        this.$router.push({ name: 'Page_shangpinxiangqingyemian' });
      },
      view_18OnClick() {
        this.$router.push({ name: 'Page_shangpinxiangqingyemian' });
      },
      view_19OnClick() {
        this.$router.push({ name: 'Page_shangpinxiangqingyemian' });
      },
      view_20OnClick() {
        this.$router.push({ name: 'Page_shangpinxiangqingyemian' });
      },
      view_21OnClick() {
        this.$router.push({ name: 'Page_shangpinxiangqingyemian' });
      },
    },
  };
</script>

<style scoped lang="css">
  .grid-item {
    background-color: rgb(255, 255, 255);
    border-radius: 0.094rem;
  }
  .image_2 {
    width: 2.25rem;
    height: 2.25rem;
  }
  .center-group {
    margin-top: 0.063rem;
    padding: 0 0.094rem;
  }
  .bottom-group {
    padding-bottom: 0.19rem;
  }
  .left-section {
    background-color: rgb(252, 182, 21);
    border-radius: 0.031rem;
    width: 0.031rem;
    height: 0.25rem;
  }
  .divider_4 {
    color: rgb(8, 4, 23);
    font-size: 0.13rem;
    line-height: 0.19rem;
    white-space: nowrap;
    position: relative;
  }
  .left-group {
    color: rgb(255, 112, 103);
    font-size: 0.19rem;
    line-height: 0.22rem;
    white-space: nowrap;
    width: 0.63rem;
  }
  .text_28 {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  .image_4 {
    width: 0.22rem;
    height: 0.22rem;
  }
  .text_24 {
    color: rgb(8, 4, 23);
    font-size: 0.19rem;
    font-weight: 500;
    line-height: 0.25rem;
    white-space: nowrap;
  }
  .text_32 {
    margin-left: 1.06rem;
    color: rgb(236, 82, 72);
    font-size: 0.16rem;
    line-height: 0.22rem;
    white-space: nowrap;
  }
  .text_26 {
    margin-left: 0.25rem;
    margin-bottom: 0.094rem;
    color: rgb(8, 4, 23);
    font-size: 0.13rem;
    line-height: 0.19rem;
    white-space: nowrap;
  }
  .page {
    background-color: #f2f2f4;
    width: 100%;
    overflow-y: auto;
    height: 100%;
  }
  .section_1 {
    padding: 0.31rem 2.72rem 0.31rem;
    background-color: rgb(255, 255, 255);
    position: relative;
  }
  .group_2 {
    padding: 0.53rem 2.63rem 1.19rem 2.63rem;
  }
  .group {
    color: rgb(67, 65, 65);
    font-size: 0.19rem;
    font-weight: 500;
    line-height: 0.19rem;
    white-space: nowrap;
    position: absolute;
    left: 2.72rem;
    top: 50%;
    transform: translateY(-50%);
  }
  .text_1 {
    color: rgb(67, 65, 65);
    font-size: 0.38rem;
    font-weight: 700;
    line-height: 0.38rem;
    white-space: nowrap;
  }
  .section_2 {
    padding-left: 0.13rem;
    background-color: rgb(255, 255, 255);
    border-radius: 0.031rem;
    position: absolute;
    right: 2.78rem;
    top: 50%;
    transform: translateY(-50%);
    border: solid 0.063rem rgb(245, 86, 86);
  }
  .grid {
    margin-top: 0.19rem;
    height: 6.66rem;
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    grid-column-gap: 0.31rem;
  }
  .image {
    width: 0.094rem;
    height: 0.16rem;
  }
  .text {
    margin-left: 0.094rem;
  }
  .group_1 {
    color: rgb(125, 122, 133);
    font-size: 0.16rem;
    line-height: 0.22rem;
    white-space: nowrap;
  }
  .text-wrapper {
    margin-left: 0.84rem;
    color: rgb(255, 255, 255);
    font-size: 0.19rem;
    font-weight: 500;
    line-height: 0.25rem;
    white-space: nowrap;
    background-color: rgb(245, 86, 86);
    border-radius: 0.031rem;
    width: 0.78rem;
    height: 0.41rem;
    border: solid 0.063rem rgb(245, 86, 86);
  }
  .section_3 {
    padding: 0.16rem 0.16rem 0 0.16rem;
    flex: 1 1 auto;
    background-color: rgb(255, 255, 255);
    border-radius: 0.13rem;
    height: 1.69rem;
  }
  .section_5 {
    margin-left: 0.22rem;
    padding: 0.13rem 0.16rem 0.28rem;
    background-color: rgb(255, 255, 255);
    border-radius: 0.13rem;
    width: 5.19rem;
    height: 1.69rem;
  }
  .image_1 {
    width: 0.38rem;
    height: 0.28rem;
  }
  .text_2 {
    margin-left: 0.13rem;
  }
  .divider {
    color: rgb(73, 69, 84);
    font-size: 0.22rem;
    font-weight: 500;
    line-height: 0.31rem;
    white-space: nowrap;
  }
  .group_4 {
    padding: 0.28rem 0.34rem 0.25rem 0.53rem;
    height: 1.22rem;
    position: relative;
  }
  .divider_2 {
    color: rgb(73, 69, 84);
    font-size: 0.22rem;
    font-weight: 500;
    line-height: 0.31rem;
    white-space: nowrap;
  }
  .group_8 {
    padding: 0.28rem 0 0.13rem;
    color: rgb(73, 69, 84);
    font-size: 0.25rem;
    font-weight: 600;
    line-height: 0.34rem;
    white-space: nowrap;
  }
  .divider_3 {
    color: rgb(125, 122, 133);
    font-size: 0.16rem;
    line-height: 0.22rem;
    white-space: nowrap;
  }
  .text_4 {
    margin-left: 0.094rem;
  }
  .text_5 {
    color: rgb(73, 69, 84);
    font-size: 0.25rem;
    font-weight: 600;
    line-height: 0.34rem;
    white-space: nowrap;
    position: absolute;
    left: 0.88rem;
    top: 0.28rem;
  }
  .text_6 {
    color: rgb(73, 69, 84);
    font-size: 0.25rem;
    font-weight: 600;
    line-height: 0.34rem;
    white-space: nowrap;
    position: absolute;
    left: 2.28rem;
    top: 0.28rem;
  }
  .text_7 {
    color: rgb(73, 69, 84);
    font-size: 0.25rem;
    font-weight: 600;
    line-height: 0.34rem;
    white-space: nowrap;
    position: absolute;
    left: 3.63rem;
    top: 0.28rem;
  }
  .group_5 {
    color: rgb(73, 69, 84);
    font-size: 0.25rem;
    font-weight: 600;
    line-height: 0.34rem;
    white-space: nowrap;
    width: 3.06rem;
    height: 0.34rem;
    position: absolute;
    right: 0.34rem;
    top: 0.28rem;
  }
  .divider_1 {
    color: rgb(125, 122, 133);
    font-size: 0.16rem;
    line-height: 0.22rem;
    white-space: nowrap;
    position: absolute;
    left: 0.53rem;
    right: 0.34rem;
    bottom: 0.25rem;
  }
  .section_4 {
    background-color: rgb(216, 216, 216);
    border-radius: 0px;
    width: 0.031rem;
    height: 0.5rem;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .text_17 {
    margin-left: 0.094rem;
  }
  .text_9 {
    margin-top: -0.34rem;
    align-self: center;
  }
  .text_10 {
    margin-top: -0.34rem;
    align-self: flex-end;
  }
  .group_6 {
    width: 3.5rem;
  }
  .group_7 {
    margin-right: 0.16rem;
    width: 2.94rem;
  }
  .text_12 {
    margin-left: 0.59rem;
  }
  .text_13 {
    margin-left: 0.59rem;
  }
  .text_15 {
    margin-left: 0.38rem;
  }
  .text_16 {
    margin-left: 0.38rem;
  }
</style>